;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:qogita-web-sellers":true});}catch(e){}}();import { CheckIcon, MinusIcon } from '@heroicons/react/20/solid'
import * as CheckboxPrimitive from '@radix-ui/react-checkbox'
import { ComponentProps } from 'react'

import { cn } from '../../utils/cn'

/**
 * Checkbox based on ShadCN
 *
 * @see https://ui.shadcn.com/docs/components/checkbox for usage
 */
export function Checkbox({
  className,
  ...props
}: ComponentProps<typeof CheckboxPrimitive.Root>) {
  return (
    <CheckboxPrimitive.Root
      className={cn(
        [
          'peer inline-grid h-4.5 w-4.5 flex-none place-items-center rounded-sm border border-gray-300 bg-white text-white',
          'data-[state=checked]:border-gray-800 data-[state=checked]:bg-gray-800 data-[state=indeterminate]:border-gray-800 data-[state=indeterminate]:bg-gray-800',
          'aria-invalid:border-error-700 aria-invalid:bg-error-50 aria-invalid:data-[state=checked]:border-error-700 aria-invalid:data-[state=checked]:bg-error-700 aria-invalid:data-[state=indeterminate]:bg-error-700 aria-invalid:data-[state=indeterminate]:border-error-700',
          'disabled:cursor-not-allowed disabled:border-gray-200 disabled:bg-white disabled:data-[state=checked]:border-gray-200 disabled:data-[state=checked]:bg-gray-200 disabled:data-[state=indeterminate]:border-gray-200 disabled:data-[state=indeterminate]:bg-gray-200',
        ],
        className,
      )}
      {...props}
    >
      <CheckboxPrimitive.Indicator
        className={cn(
          // px translate is here for better optical centering of the icon
          'group flex items-center justify-center text-current',
        )}
      >
        <CheckIcon className="hidden h-4 w-4 group-data-[state=checked]:block" />
        <MinusIcon className="hidden h-4 w-4 group-data-[state=indeterminate]:block" />
      </CheckboxPrimitive.Indicator>
    </CheckboxPrimitive.Root>
  )
}
